import {
  AUTH_EMAIL_LOGIN,
  AUTH_MAGIC_LINK_LOGIN,
  REGISTER
} from 'portal/constants/Routes';
import { CLOUD, SKY } from 'styles/Colors';

import ArrowPhone from 'images/ContainerIcons/ArrowPhone.svg';
import AuthLayout from 'auth/AuthLayout';
import ButtonGroup from '@opploans/button-group-component/ButtonGroup';
import LinkButton from '@opploans/link-button-component/LinkButton';
import React from 'react';

const linkButtonStyles = {
  textDecoration: 'underline',
  marginTop: '1rem',
  width: '100%',
  textAlign: 'center'
};

const buttonStyle = {
  color: SKY
};

function AuthLogin({ navigate }) {
  const options = [
    {
      value: 'magic_link',
      displayValue: 'Login with a secure link',
      unselectedChildren: (
        <div
          css={{
            alignItems: 'center',
            display: 'flex',
            height: '1.5rem',
            color: SKY
          }}
        >
          <ArrowPhone css={{ marginRight: '0.5rem', height: '100%' }} />
          <p>Login with a secure link</p>
        </div>
      ),
      selectedChildren: (
        <div
          css={{
            alignItems: 'center',
            display: 'flex',
            height: '1.5rem',
            color: SKY
          }}
        >
          <ArrowPhone css={{ marginRight: '0.5rem', height: '100%' }} />
          <p>Login with a secure link</p>
        </div>
      )
    }
  ];

  return (
    <AuthLayout title='Welcome!' subTitle='Log in to continue to your account.'>
      <ButtonGroup
        direction='column'
        options={options}
        onClick={(value) => {
          if (value === 'magic_link') {
            navigate(AUTH_MAGIC_LINK_LOGIN);
          } else {
            navigate(AUTH_EMAIL_LOGIN);
          }
        }}
        additionalContentStyle={buttonStyle}
        additionalButtonStyle={{ background: CLOUD }}
      />
      <LinkButton
        lightBackground
        additionalStyle={linkButtonStyles}
        onClick={() => navigate(REGISTER)}
      >
        Don’t have an account? Apply for a loan here
      </LinkButton>
    </AuthLayout>
  );
}

export default AuthLogin;
